import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { BusinessNameBankAccountDataForm, BusinessNameBankAccountFilters } from '../../../../app/models/BusinessNameBankAccount';
import BusinessNameBankAccountSwitchChange from '../BusinessNameBankAccountSwitchChange';

interface Props {
    businessNamebankAccounts: BusinessNameBankAccountDataForm[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: BusinessNameBankAccountFilters;
    setFilter: (filter: BusinessNameBankAccountFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
    notActions?: boolean;
}

const BusinessNameBankAccountDataTable = ({
    businessNamebankAccounts,
    totalRows,
    loading = false,
    edit,
    destroy,
    show,
    filter,
    setFilter,
    callbackSuccess,
    notActions=true
}: Props) => {
    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: BusinessNameBankAccountDataForm, index: any, column: any) => <span className="">{row.id}</span>
        },
        {
            name: 'Banco',
            selector: (row: any) => row.bank,
            sortable: true,
            sortField: 'bank',
            cell: (row: BusinessNameBankAccountDataForm, index: any, column: any) => (
                <span className="">{row.bank?.name}</span>
            )
        },
        {
            name: 'Tipo de cuenta',
            selector: (row: any) => row.account_type,
            sortable: true,
            sortField: 'account_type',
            cell: (row: BusinessNameBankAccountDataForm, index: any, column: any) => (
                <span className="">{row.account_type?.name}</span>
            )
        },
        {
            name: 'Razón de la cuenta',
            selector: (row: any) => row.bank_account_reason,
            sortable: true,
            sortField: 'bank_account_reason',
            cell: (row: BusinessNameBankAccountDataForm, index: any, column: any) => (
                <span className="">{row.bank_account_reason?.name}</span>
            )
        },
        {
            name: 'Número de cuenta',
            selector: (row: any) => row.account_number,
            sortable: true,
            sortField: 'account_number',
            cell: (row: BusinessNameBankAccountDataForm, index: any, column: any) => (
                <span className="">{row.account_number}</span>
            )
        },

        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: BusinessNameBankAccountDataForm, index: any, column: any) => (
                notActions
                  ? row.is_active ? 'Sí' : 'No'
                  : (
                    <BusinessNameBankAccountSwitchChange
                      checkValue={row.is_active ?? true}
                      businessNameBankAccountId={row.id!}
                      callbackSuccess={callbackSuccess!}
                    />
                  )
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            omit: notActions,
            cell: (row: BusinessNameBankAccountDataForm, index: any, column: any) => (
                <div className="">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    {/* <BankFilters filter={filter} setFilter={setFilter} /> */}
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={businessNamebankAccounts}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default BusinessNameBankAccountDataTable;
